/**
 * @name setTabSelecter
 * @description .js-tab-selecterの要素内の、[data-tab]属性の値と一致する{#ID}の要素にクラスを付与する
 * @param {Object} tabSelecter .js-tab-selecterの要素
 * @param {Object} tabTriggers .js-tab-triggerの要素
 * @param {Object} tabTargets .js-tab-targetの要素
 * @param {Object} currentMenu クリックした要素
 * @param {Object} currentContent クリックした要素の[data-tab]属性の値と一致する{#ID}の要素
 */
export function setTabSelecter() {
    const tabSelecter = document.querySelectorAll(".js-tab-selecter");
    if (tabSelecter.length === 0) return;

    tabSelecter.forEach((el) => {
        const tabTriggers = el.querySelectorAll(".js-tab-trigger");
        const tabTargets = el.querySelectorAll(".js-tab-target");

        for (let i = 0; i < tabTriggers.length; i++) {
            tabTriggers[i].addEventListener("click", (e) => {
                let currentMenu = e.currentTarget;
                let currentContent = document.getElementById(currentMenu.dataset.tab);
                let currentText = currentContent.querySelector('.text');

                for (let i = 0; i < tabTriggers.length; i++) {
                    tabTriggers[i].classList.remove("isSelect");
                }

                currentMenu.classList.add("isSelect");

                for (let i = 0; i < tabTargets.length; i++) {
                    tabTargets[i].classList.remove("isShow");
                }
                if (currentContent !== null) {
                    currentContent.classList.add("isShow");
                    currentContent.style.setProperty('--view-area-height', `${currentText.getBoundingClientRect().height}px`);
                }
            });
        }
    });
};